import { BadgeCheck } from 'lucide-react';
import { getAvatarColor, getUserInitials } from '@/components/common/avatarHelpers';
import { cn } from '@/lib/utils';
import { roleLabels } from './userDisplay';
import type { User } from '@/types/user.types';

interface UserIdentityProps {
  user: User;
  size?: 'md' | 'lg';
}

// Bloco de identidade do usuário: avatar + nome (com selo de verificado) +
// "cargo · telefone". Compartilhado pela linha (desktop) e pelo card (mobile).
export function UserIdentity({ user, size = 'md' }: UserIdentityProps) {
  const cargo = roleLabels[user.role] || user.cargo || user.role;
  return (
    <div className="flex min-w-0 items-center gap-3">
      <div
        className={cn(
          'flex shrink-0 items-center justify-center rounded-full font-bold tracking-tight',
          size === 'lg' ? 'size-11 text-base' : 'size-10 text-sm',
          getAvatarColor(user.id)
        )}
      >
        {getUserInitials(user.name)}
      </div>
      <div className="min-w-0">
        <p className="flex items-center gap-1 font-semibold leading-tight text-text-title">
          <span className="truncate">{user.name}</span>
          {user.verified && (
            <BadgeCheck size={15} className="shrink-0 text-info" aria-label="Verificado" />
          )}
        </p>
        <p className="truncate text-xs leading-tight text-text-secondary">
          {cargo} · {user.phone}
        </p>
      </div>
    </div>
  );
}
